import { render, staticRenderFns } from "./OnboardingCompanyRentalCarsPricing.vue?vue&type=template&id=bd571ea2"
import script from "./OnboardingCompanyRentalCarsPricing.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyRentalCarsPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports